module.exports = __webpack_public_path__ + "static/media/mobile-contactUs-bg-2.fa09f726.svg";